import React, { FC } from "react";

const PageSubtitle: FC = ({ children }) => {
  return <p className="px-[15px] md:px-[10px] lg:px-[15px] mb-4">{children}</p>;
};

export default PageSubtitle;
